import axios from "axios";
import axiosInstance from "../../../../helpers/axiosConfig";
import config from "../../../../config";

const baseUrl = config.REACT_APP_BASE_URL//process.env.REACT_APP_BASE_URL

export class ApplicationService {

    static async enrolmentData(id) {

        try {

            const response = await axios.get(`${baseUrl}Enrollment/${id}`);
            const data = response.data;
            //console.log('enrollment service: ', data);
            return data;

        } catch (error) {

        }
    }


    static async applicationProfessions() {
        try {
            const data = await axios.get(`${baseUrl}Common/Professions`);
            //console.log('data professions service: ', data)

            return data
        } catch (error) {

        }
    }

    static async sendForm(data) {

        try {
          const response = await axiosInstance.post('Member/CompleteEnrollment',
            data,
            {
              headers: { 'Content-Type': 'application/json' },
            }
          )
    
          //console.log('register information: ', response)
          return response
        } catch (error) {
          // console.error('Register catch Error:', error)
          throw error
        }
    
      }

}